/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring";

import { isProfileComplete } from "./Private";
import FeatureFlags from "../FeatureFlags";
import withLanguage from "./withLocaleChange";
import { inferLocale } from "./common/Gettext";
import { mapDispatchToFetch } from "./common/fetch";
import { withDeposit } from "./common/withDeposit";

import type { State as GlobalState } from "../redux/reducer";
import { REGISTER_TAB_ID } from "./Auth/Auth";

type State = {
  changeLocaleFetching: boolean,
  isNavActive: boolean,
};

type Props = {
  dispatch: Function,
  onLocaleChange: Function,

  match: Object,
  location: Object,
  history: Object,

  isIOS: boolean,
  appVersion: number,
  currencySettings: Object,
  isAndroidApp: boolean,
  isVIP: boolean,
  geo: string,
  locale: string,
  locales: Object,
  profile: Object,
  profileStatus: string,
  authTab: string,
  shouldDisplayMainHeader: boolean,
  showMainHeader: boolean,

  children: Function | React.Node,
};

class _Logic extends React.Component<Props, State> {
  state = {
    changeLocaleFetching: false,
    isNavActive: false,
    isIndexNavActive: false,
  };

  toggle = () => {
    this.setState({ isNavActive: !this.state.isNavActive });
  };

  indexToggle = () => {
    this.setState({ isIndexNavActive: !this.state.isIndexNavActive });
  };

  hide = () => {
    this.setState({ isNavActive: false });
  };

  showTopLinks = () => {
    if (
      this.props.location.pathname === "/" ||
      this.props.location.pathname === "/register" ||
      this.props.location.pathname === "/password-update" ||
      (this.props.isIOS && this.props.appVersion <= 2000000)
    ) {
      return false;
    }
    return true;
  };

  showLinks = () => {
    if (process.env.REACT_APP_DEPLOY_TARGET === "eztrader") {
      return false;
    }

    if (this.props.isIOS && this.props.appVersion <= 2000000) {
      return false;
    }

    if (this.props.location.pathname.startsWith("/fillup")) {
      return false;
    }

    switch (this.props.location.pathname) {
      case "/trade":
      case "/trading-history":
      case "/profile":
      case "/profile2":
      case "/fillup":
      case "/withdraw":
      case "/finance-history":
      case "/billing/offline":
      case "/verification":
      case "/password-update":
        return false;
      default:
        return true;
    }
  };

  showLoginForm = (payload) => {
    this.props.dispatch({
      type: "DISPLAY_AUTH_TAB",
      payload,
    });
    this.props.dispatch({
      type: "DISPLAY_AUTH_FORM",
      payload: true,
    });
  };

  componentDidMount() {
    if (window.isFullAndroidApp) {
      this.props.dispatch({
        type: "DISPLAY_AUTH_TAB",
        payload: REGISTER_TAB_ID,
      });
    }
  }

  changeXLocaleWithLocale = (locale: string) => {
    this.props.onLocaleChange(locale);
    this.props.dispatch({
      type: "UPDATE_HELPDESK_LOCALE",
      payload: locale,
    });
  };

  render() {
    const { children, ...props } = this.props;

    const { appVersion, isIOS, profile } = props;
    const { path } = props.match;

    const isLoggedIn = profile != null;
    const isAppLogin = isIOS && appVersion <= 2000000;
    const isHelpdesk =
      path.startsWith("/helpdesk") || path.startsWith("/test-for-users");
    const isMainPage = props.location.pathname === "/";
    const isNews =
      FeatureFlags.enableHelpdeskNews === true &&
      FeatureFlags.showHelpdeskNewsRoute === true &&
      path.startsWith("/news");
    const isMobileApp = isIOS || props.isAndroidApp;
    const showLangSelect = (isIOS && path === "/login") || !isIOS;

    const query = querystring.parse(props.location.search.slice(1));

    let authTab = props.authTab;
    switch (props.profileStatus) {
      case "AVAILABLE": {
        if (isProfileComplete(props.profile)) {
          authTab = "loggedin";
        } else {
          authTab = "social_register";
        }
        break;
      }
      case "INVALID":
        if (query.action === "password") {
          authTab = "social_password";
        }
        break;
      default:
        authTab = props.authTab;
    }

    if (typeof children === "function") {
      return children({
        ...props,
        ...this.state,

        isLoggedIn,
        isAppLogin,
        isHelpdesk,
        isMainPage,
        isNews,
        showLangSelect,
        isMobileApp,
        authTab,

        activeTab: authTab,
        query,
        email: query.email,
        toggle: this.toggle,
        hide: this.hide,
        indexToggle: this.indexToggle,
        showTopLinks: this.showTopLinks,
        showLinks: this.showLinks,
        showLoginForm: this.showLoginForm,
        changeXLocaleWithLocale: this.changeXLocaleWithLocale,
      });
    }

    return children;
  }
}

function mapStateToProps(state: GlobalState, props) {
  return {
    appVersion: state.serverData && state.serverData.app_version,
    currencySettings: state.serverData && state.serverData.currency_settings,
    isIOS: state.serverData && state.serverData.isIOS,
    isAndroidApp: state.serverData && state.serverData.isAndroidApp,
    isVIP: state.serverData && state.serverData.isVIP,
    geo: state.serverData && state.serverData.geo,
    locale: inferLocale(state),
    locales: state.apiConfigs && state.apiConfigs.locales,
    profile: state.profile,
    profileStatus: state.dataRequirementsStatus.profile,
    authTab: state.authForm.displayTab || "login",
    shouldDisplayMainHeader: state.authForm.displayForm || props.showMainHeader,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToFetch
  )(withDeposit(withLanguage(_Logic)))
);



// WEBPACK FOOTER //
// ./src/components/UnitedHeaderLogic.js